import { Link } from 'react-router-dom';
import { Check, ArrowUpRight } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { whyUs } from '../data/content';
import { img } from '../data/site';

export const WhyUs = () => (
  <section data-testid="why-us-section" className="grain relative overflow-hidden bg-pine">
    <div
      className="pointer-events-none absolute -left-40 top-0 h-[420px] w-[420px] rounded-full bg-forest/60 blur-[120px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border border-goldlight/40" aria-hidden="true" />
          <div className="img-frame aspect-[4/3] shadow-[0_40px_90px_-36px_rgba(0,0,0,0.7)]">
            <img
              src={img('photo-1573164574572-cb89e39749b4')}
              alt="African professionals in a TheBigHub strategy session mapping out a client's growth plan"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 right-6 rounded-2xl bg-goldlight px-6 py-4 shadow-xl">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-pine/70">One Roof</p>
            <p className="font-display text-2xl font-bold text-pine">8 Services</p>
          </div>
        </Reveal>
        <div className="order-1 lg:order-2">
          <SectionHeading
            dark
            chapter="03"
            eyebrow="Why Choose TheBigHub"
            title="Your Growth Deserves a Strategic Partner."
            copy="Digital growth is more than posting content or running advertisements. It requires the right strategy, creative execution, and consistent attention to your business goals."
          />
          <ul className="mt-10 grid gap-x-8 gap-y-4 sm:grid-cols-2">
            {whyUs.map((w, i) => (
              <Reveal key={w} delay={i * 0.06}>
                <li className="flex items-start gap-3 text-sm leading-relaxed text-white">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-goldlight/15 text-goldlight">
                    <Check size={12} strokeWidth={3} />
                  </span>
                  {w}
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.2}>
            <Link to="/about" data-testid="why-us-about-link" className="btn-outline-light mt-10">
              More About TheBigHub <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
